<template>
  <div class="elevation-1">
    <v-toolbar class="" flat>
      <v-btn flat to="/channels/inputs"> Inputs </v-btn>
      <v-btn flat v-if="$is_admin()" to="/channels/outputs"> Outputs </v-btn>
      <v-btn flat v-if="$is_admin()" to="/channels/access_groups"> Access groups </v-btn>
      <v-btn flat v-if="$is_privilege('developer')" to="/channels/configuration_presets"> Configuration presets </v-btn>
    </v-toolbar>
    <router-view></router-view>
  </div>
</template>


<script>
import ChannelInputList from './channels/InputList'
import ChannelOutputList from './channels/OutputList'
import ConfigurationPresetList from './channels/ConfigurationPresetList'
import Editor from './channels/Editor'
import ConfigurationPresetEditor from './channels/ConfigurationPresetEditor'

import AccessGroupList from './channels/AccessGroupList'
import AccessGroupEditor from './channels/AccessGroupEditor'

export default {
  routes: [
    {
      path: '',
      redirect: '/channels/inputs'
    },
    {
      path: "inputs",
      component: ChannelInputList,
      children: [
        {
          path: '',
          redirect: '/channels/inputs/list'
        },
        {
          path: "new",
          name: "New input channel",
          components: {
            default: ChannelInputList,
            bottomEditor: Editor
          },
          props: {
            default: false,
            bottomEditor: true
          },
          meta: {
            edit: "Edit input channel"
          }
        },
        {
          path: "edit/:id",
          name: "Edit input channel",
          components: {
            default: ChannelInputList,
            bottomEditor: Editor
          },
          props: {
            default: false,
            bottomEditor: true
          },
        },
        {
          path: "list",
          name: "Input list",
          component: ChannelInputList
        }
      ]
    },
    {
      path: "outputs",
      component: ChannelOutputList,
      children: [
        {
          path: '',
          redirect: '/channels/outputs/list'
        },
        {
          path: "new",
          name: "New output channel",
          components: {
            default: ChannelOutputList,
            bottomEditor: Editor
          },
          props: {
            default: false,
            bottomEditor: true
          },
          meta: {
            edit: "Edit output channel"
          }
        },
        {
          path: "edit/:id",
          name: "Edit output channel",
          components: {
            default: ChannelOutputList,
            bottomEditor: Editor
          },
          props: {
            default: false,
            bottomEditor: true
          },
        },
        {
          path: "list",
          name: "Output list",
          component: ChannelOutputList
        }
      ]
    },
    {
      path: "configuration_presets",
      component: ConfigurationPresetList,
      children: [
        {
          path: '',
          redirect: '/channels/configuration_presets/list'
        },
        {
          path: "new",
          name: "New configuration preset",
          components: {
            default: ConfigurationPresetList,
            bottomEditor: ConfigurationPresetEditor
          },
          props: {
            default: false,
            bottomEditor: true
          },
          meta: {
            edit: "Edit configuration preset"
          }
        },
        {
          path: "edit/:id",
          name: "Edit configuration preset",
          components: {
            default: ConfigurationPresetList,
            bottomEditor: ConfigurationPresetEditor
          },
          props: {
            default: false,
            bottomEditor: true
          },
        },
        {
          path: "list",
          name: "Configuration Preset list",
          component: ConfigurationPresetList
        }
      ]
    },
    {
      path: "access_groups",
      component: AccessGroupList,
      children: [
        {
          path: '',
          redirect: '/channels/access_groups/list'
        },
        {
          path: "new",
          name: "New channel access group",
          components: {
            default: AccessGroupList,
            bottomEditor: AccessGroupEditor
          },
          props: {
            default: false,
            bottomEditor: true
          },
          meta: {
            edit: "Edit channel access group"
          }
        },
        {
          path: "edit/:id",
          name: "Edit channel access group",
          components: {
            default: AccessGroupList,
            bottomEditor: AccessGroupEditor
          },
          props: {
            default: false,
            bottomEditor: true
          },
        },
        {
          path: "list",
          name: "Channel access group list",
          component: AccessGroupList
        }
      ]
    }

  ],

}
</script>
